export function plural(
  n: number,
  singular = "phone number",
  plural = "phone numbers"
): string {
  return n === 1 ? `1 ${singular}` : `${n.toLocaleString()} ${plural}`;
}
